import type { WorldMode } from "./types";

export const MAX_RENDERER_RECOVERY_ATTEMPTS = 2;
export interface TierSignals {
  preference?: WorldMode;
  reducedMotion: boolean;
  dataSaver: boolean;
  balancedCapable: boolean;
  cinematicOptIn: boolean;
}

export function selectWorldMode(signals: TierSignals): WorldMode {
  if (signals.preference === "off") return "off";
  if (signals.reducedMotion || signals.dataSaver) return "static";
  if (signals.preference === "cinematic") return signals.cinematicOptIn ? "cinematic" : "static";
  if (signals.preference === "balanced") return signals.balancedCapable ? "balanced" : "static";
  if (signals.preference === "lite") return "lite";
  return "static";
}

export function canRecover(attempts: number) {
  return attempts < MAX_RENDERER_RECOVERY_ATTEMPTS;
}
